export default "__VITE_ASSET__77fb3187__"